import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 100%;
    margin: 0 auto;
`;

export const AlertWrapper = styled.div`
  width: 100%;
  margin: 1rem 0;
  display: block;

  & > * {
    width: 100% !important;
    min-width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
`;